<template>
	<div>
		<TableList :scroll="{x:1800}" :is_created_get_list="false" @changeStatus='changeStatus'
			:form_data_seo.sync="form_data_seo" :columns="columns_list" :get_table_list="this.get_table_list"
			:slot_table_list="['operation','status','factory_name','work_time','lack_num','lack_day','supplement_day','status','pass_status_name2','supplement_num','completion_rate']"
			:submit_preprocessing="submit_preprocessing" ref="list">
			<template slot="form_after">
				<div v-if='tab_index == 0' class='page_content_top page_content'>
					<div>
						<a-statistic title="应打卡人数" :value-style="{ color: '#2f54eb' }"
							:value="dayCount.should_user_num" />
					</div>
					<div>
						<a-statistic title="应打总次数" :value-style="{ color: '#2f54eb' }"
							:value="dayCount.should_user_num" />
					</div>
					<div>
						<a-statistic title="打卡合格人数" :value-style="{ color: '#48AD23' }"
							:value="dayCount.qualified_user_num" />
					</div>
					<div>
						
						<a-statistic title="缺卡人数" :value-style="{ color: 'red' }" :value="dayCount.lack_user_num" />
					</div>
					<div>
						
						<a-statistic title="缺卡次数" :value-style="{ color: 'red' }" :value="dayCount.lack_total" />

					</div>

				</div>

				<div v-if='tab_index == 1' class='page_content_top page_content'>
					<div>
						<a-statistic title="应打卡人数" :value-style="{ color: '#2f54eb' }"
							:value="dayCount.should_user_num" />
					</div>
					<div>
						<a-statistic title="实际打卡人数" :value-style="{ color: '#2f54eb' }"
							:value="dayCount.done_user_num" />
					</div>
					<div>
						<a-statistic title="月合格人数" :value-style="{ color: '#2f54eb' }"
							:value="dayCount.qualified_user_num" />
					</div>
					<div>
						<a-statistic title="应打卡总次数" :value-style="{ color: '#48AD23' }"
							:value="dayCount.should_total" />
					</div>
					<div>
						<a-statistic title="实际打卡总次数" :value-style="{ color: '#48AD23' }" :value="dayCount.done_total" />
					</div>

					<div>
						<a-statistic title="月均缺卡人数" :value-style="{ color: 'red' }"
							:value="dayCount.supplement_user_num" />
					</div>
					<div>
						<a-statistic title="缺卡总次数" :value-style="{ color: 'red' }" :value="dayCount.lack_total" />
					</div>
					<div>
						<a-statistic title="月补卡人数" :value-style="{ color: '#B97104' }"
							:value="dayCount.lack_user_num" />
					</div>
					<div>
						<a-statistic title="月补卡总次数" :value-style="{ color: '#B97104' }"
							:value="dayCount.supplement_total" />
					</div>

				</div>
			</template>
			<template slot="status" slot-scope="data">
				<p :class='data.record.status==1?"can":"nocan"'>
					{{data.record.status==1?'生效中':'禁用'}}
				</p>
			</template>

			<template slot="lack_num" slot-scope="data">
				<p :style="{color:'red'}">
					{{data.record.lack_num}}
					
				</p>

			</template>

			<template slot="before">
				<div class="table_before">
					<div class="left">
						<a-tabs type="card" @change="tab_change" class='tab_info'>
							<a-tab-pane :key="0" tab="日统计"></a-tab-pane>
							<a-tab-pane :key="1" tab="月统计"></a-tab-pane>
						</a-tabs>
					</div>
					<div class="right_btn" v-if='tab_index == 0'> 
					<a :href="'/manage/station.report/exportDayInfo' | export_form"  target="_blank">
						<a-button  class="a_btn">导出</a-button>
					</a>
						
					</div>
					
					<div class="right_btn" v-if='tab_index == 1'>
						<a :href="'/manage/station.report/exportMonthInfo' | export_form"  target="_blank">
							<a-button class="a_btn">导出</a-button>
						</a>
					</div>
				</div>
			</template>

			<template slot="use_num" slot-scope="data">
				<p>
					<span>
						<a @click='see_user(data.record)'>
							{{data.record.use_num}}
						</a>
					</span>
				</p>
			</template>

			<template slot="completion_rate" slot-scope="data">
				<p>
					<span>
						{{data.record.completion_rate}}%
					</span>
				</p>
			</template>

			<template slot="factory_name" slot-scope="data">
				<p><a @click='see_rule(data.record)'>

						{{data.record.factory_name}}
					</a></p>
				<p>
					ID：{{data.record.factory_id}}
				</p>
			</template>
			<template slot="work_time" slot-scope="data">
				<p :class='data.record.frequency.type!=1?"nowTime":"wTime"'>
					{{data.record.frequency.text}}
				</p>
			</template>
			<template slot="operation" slot-scope="data">
				<p>
					<span>
						<a @click='get_details(data.record)'>
							查看
						</a>
						<a-divider type="vertical" />
						<a v-if='data.record.lack_num>0' @click='get_reissuevisible(data.record)'>
							补卡
						</a>
					</span>
				</p>
			</template>
			<template slot="pass_status_name2" slot-scope="data">
				<p>
					<a @click='get_pass_details(data.record)'>
						查看
					</a>
				</p>
			</template>

			<!-- 月 -->
			<template slot="lack_day" slot-scope="data">
				<p @click="num_change(data.record,'lack')" class='pointer' :style="{color:'red'}">
					{{data.record.lack_day}}
				</p>

			</template>

			<template slot="lack_num" slot-scope="data">
				<p @click="num_change(data.record,'lack')" class='pointer' :style="{color:'red'}">
					{{data.record.lack_num}}

				</p>

			</template>


			<template slot="supplement_day" slot-scope="data">
				<p @click="num_change(data.record,'supplement')" class='pointer' :style="{color:'#B97104'}">
					{{data.record.supplement_day}}
				</p>

			</template>
			<template slot="supplement_num" slot-scope="data">
				<p @click="num_change(data.record,'supplement')" class='pointer' :style="{color:'#B97104'}">
					{{data.record.supplement_num}}
				</p>

			</template>


		</TableList>

		<supInfo  ref='supInfo' :visible.sync="drawer_visible"></supInfo>

		<a-modal title="查看规则" width='30%' :maskClosable='true' :visible="see_visible" @cancel='see_visible=false'
			@ok='see_visible=false'>
			<div>
				<a-descriptions :column='2'>
					<a-descriptions-item label="工厂名称">
						{{see_info.factory_name}}
					</a-descriptions-item>
					<a-descriptions-item label="工厂ID">
						{{see_info.id}}
					</a-descriptions-item>
					<a-descriptions-item label="工厂地址">
						{{see_info.address}}
					</a-descriptions-item>
					<a-descriptions-item label="打卡半径">
						{{see_info.radius}}米
					</a-descriptions-item>

				</a-descriptions>
				<a-alert class="mt10" message="旺季打卡规则" banner type="info" show-icon>
					<template #icon><a-icon type="caret-right" /></template>
				</a-alert>
				<div class="mt10">
					<p class="mt10"><span
							class="red">*</span><span>旺季白班时间：{{see_info.peak_day_start}}~{{see_info.peak_day_end}}</span>
					</p>
					<p class="mt10"><span
							class="red">*</span><span>旺季晚班时间：{{see_info.peak_night_start}}~{{see_info.peak_night_end}}</span>
					</p>
					<p class="mt10"><span
							class="red">*</span><span>旺季打卡频率：<span>每{{see_info.peak_frequency}}小时打卡1次</span></span></p>
				</div>
				<a-alert class="mt10" message="淡季打卡规则" banner type="info" show-icon>
					<template #icon><a-icon type="caret-right" /></template>
				</a-alert>
				<div class="mt10">
					<p class="mt10"><span
							class="red">*</span><span>淡季白班时间：{{see_info.off_day_start}}~{{see_info.off_day_end}}</span>
					</p>
					<p class="mt10"><span
							class="red">*</span><span>淡季晚班时间：{{see_info.off_night_start}}~{{see_info.off_night_end}}</span>
					</p>
					<p class="mt10"><span
							class="red">*</span><span>淡季打卡频率：<span>每</span>{{see_info.off_frequency}}<span>小时打卡1次</span></span>
					</p>
				</div>
				<a-alert class="mt10" message="其他规则" banner type="info" show-icon>
					<template #icon><a-icon type="caret-right" /></template>
				</a-alert>
				<div class="mt10">
					<p class="mt10"><span class="red">*</span><span>容错窗口：前后{{see_info.tolerance}}分钟</span></p>
					<p class="mt10">容错期内打卡视为合规，超出容错期，则不可打卡</p>
				</div>
			</div>
		</a-modal>


		<a-drawer :title="visibleDrawerInfs.info.username+'· 打卡明细'" placement="right" :closable="false"
			:visible="visibleDrawer" @close="visibleDrawer=false">
			<a-drawer title="打卡明细" placement="right" width="50%" :visible="visibleDrawer" @close="visibleDrawer=false"
				:body-style="{ padding: '24px' }">
				<!-- 顶部统计区域 -->
				<div class="statistics-container">
					<a-row :gutter="16">
						<!-- 左侧 8 个卡片（分两行） -->
						<a-col :span="18">
							<!-- 第一行 -->
							<a-row :gutter="[16, 16]" style="margin-bottom: 16px;">
								<a-col :span="6">
									<div class="stat-card card-blue">
										<div class="stat-value">{{visibleDrawerInfs.info.should_day}}</div>
										<div class="stat-label">应打天数</div>
									</div>
								</a-col>
								<a-col :span="6">
									<div class="stat-card card-cyan">
										<div class="stat-value">{{visibleDrawerInfs.info.done_day}}</div>
										<div class="stat-label">实际天数</div>
									</div>
								</a-col>
								<a-col :span="6">
									<div class="stat-card card-red">
										<div class="stat-value">{{visibleDrawerInfs.info.lack_day}}</div>
										<div class="stat-label">缺卡天数</div>
									</div>
								</a-col>
								<a-col :span="6">
									<div class="stat-card card-orange">
										<div class="stat-value">{{visibleDrawerInfs.info.supplement_day}}</div>
										<div class="stat-label">补卡天数</div>
									</div>
								</a-col>
							</a-row>
							<!-- 第二行 -->
							<a-row :gutter="16">
								<a-col :span="6">
									<div class="stat-card card-blue">
										<div class="stat-value">{{visibleDrawerInfs.info.should_num}}</div>
										<div class="stat-label">应打次数</div>
									</div>
								</a-col>
								<a-col :span="6">
									<div class="stat-card card-cyan">
										<div class="stat-value">{{visibleDrawerInfs.info.done_num}}</div>
										<div class="stat-label">实际次数</div>
									</div>
								</a-col>
								<a-col :span="6">
									<div class="stat-card card-red">
										<div class="stat-value">{{visibleDrawerInfs.info.lack_num}}</div>
										<div class="stat-label">缺卡次数</div>
									</div>
								</a-col>
								<a-col :span="6">
									<div class="stat-card card-orange">
										<div class="stat-value">{{visibleDrawerInfs.info.supplement_num}}</div>
										<div class="stat-label">补卡次数</div>
									</div>
								</a-col>
							</a-row>
						</a-col>

						<!-- 右侧完成率大卡片 -->
						<a-col :span="6">
							<div class="stat-card card-cyan-large">
								<div class="stat-value-large">{{visibleDrawerInfs.info.completion_rate}}%</div>
								<div class="stat-label">完成率</div>
							</div>
						</a-col>
					</a-row>
				</div>

				<!-- 表格区域 -->
				<div class="table-container">
					<!-- 表格头部 -->
					<div class="table-header">
						<div class="table-title">
							<a-icon type="calendar" style="color: #1890ff; font-size: 16px; margin-right: 8px;" />
							<span>每日打卡统计</span>
						</div>
						<a-button @click='goReport' type="link" size="small">
							导出 <a-icon type="upload" />
						</a-button>
					</div>

					<!-- 表格内容 -->
					<a-table :columns="columnsDrawer" :dataSource="visibleDrawerInfs.list" :pagination="false"
						rowKey="id" size="middle" bordered>
						<!-- 自定义渲染：淡旺季 -->
						<template slot="season" slot-scope="text,data">
							<span v-if="data.season_text === '旺季'" class="season-tag">旺季</span>
							<span v-else>{{ data.season_text }}</span>
						</template>

						<!-- 自定义渲染：完成率 -->
						<template slot="completion_rate" slot-scope="text">
							<span :style="{ color: getRateColor(text) }">{{ text }}</span>
						</template>
					</a-table>
				</div>
			</a-drawer>
		</a-drawer>


		<a-modal :title="columns_list_title" width='50%' :maskClosable='true' :visible="num_visible"
			@cancel='num_visible=false' @ok='num_visible=false'>

			<div style="color:red;margin-bottom: 12px;">
				合计{{columns_list_subtitle}}： {{num_list.total_day}} 天 | 共 {{num_list.total_num}} 次
			</div>


			<a-table :data-source="num_list.list" :columns="columns_list_num"></a-table>

		</a-modal>


		<a-modal title="缺卡次数" width='50%' :maskClosable='true' :visible="data_visible"
			@cancel='data_visible=false' @ok='data_visible=false'>

			<div style="color:red;margin-bottom: 12px;">
				合计：共{{data_time.length}} 次
			</div>
			
			<span class="dateTag" v-for="(it,indx) in data_time" :key='indx'>
				{{it}}
			</span>
			


		</a-modal>



		<EditPop width='50%' @handleSubmit="handleSubmit" :form_data="form_data" :visible.sync="reissuevisible">
			<template slot="rule_user">
				<a-alert :show-icon="false" :message="`当前人员${tims.info.username}，${tims.info.date}日
					有${tims.info.lack_num}缺卡`" banner />
			</template>
		</EditPop>

	</div>
</template>
<script>
	import EditPop from "@/components/EditPop";
	import Form from "@/components/Form";
	import TableList from "@/components/TableList";
	import supInfo from "@/views/dispatch/supInfo.vue";

	import {
		message
	} from 'ant-design-vue';
	import {
		getDayDetail,
		getDayCount,
		getMonthCount,
		getDayList,
		getMonthList,
		getRuleDetail,
		getFactoryRule,
		getSeasonSelect,
		getMonthDetail,
		getMonthTypeDetail,
		exportMonthDetail,
		getSupplementTimes,
		supplementClock
	} from "@/api/dispatch";

	let columns = [{
			title: "日期",
			dataIndex: "date",
		},
		{
			title: "人员信息",
			dataIndex: "username",
			scopedSlots: {
				customRender: "username"
			}
		}, {
			title: "驻场工厂",
			dataIndex: "factory_name",
			scopedSlots: {
				customRender: "factory_name"
			}
		},

		{
			title: "班次",
			dataIndex: "shift_text",

		},
		{
			title: "分管领导",
			dataIndex: "leader_name",
		},

		{
			title: "当前打卡频率",
			dataIndex: "work_time",
			scopedSlots: {
				customRender: "work_time"
			}
		},

		{
			title: "开始时间",
			dataIndex: "start_time",
		},
		{
			title: "最后结束时间",
			dataIndex: "last_time",
		},
		{
			title: "应打卡次数",
			dataIndex: "should_num",
		},
		{
			title: "已打卡次数",
			dataIndex: "done_num",
		},
		{
			title: "缺卡次数",
			dataIndex: "lack_num",
			scopedSlots: {
				customRender: "lack_num"
			}
		},
		{
			title: "操作",
			scopedSlots: {
				customRender: "operation"
			},
					fixed: 'right',
		},
	];

	let columns_month = [{
			title: "月份",
			dataIndex: "month",
		}, {
			title: "人员信息",
			dataIndex: "username",
		},
		{
			title: "部门",
			dataIndex: "department_name",
		},
		{
			title: "岗位",
			dataIndex: "role_name",
		},
		{
			title: "驻场工厂",
			dataIndex: "factory_name",
		},
		{
			title: "淡/旺季",
			dataIndex: "season_text",
		},
		{
			title: "应打卡(天)",
			dataIndex: "should_day",
		},
		{
			title: "实打卡(天)",
			dataIndex: "done_day",
		},
		{
			title: "缺卡(天)",
			dataIndex: "lack_day",
			scopedSlots: {
				customRender: "lack_day"
			}

		},
		{
			title: "补卡(天)",
			dataIndex: "supplement_day",
			scopedSlots: {
				customRender: "supplement_day"
			}
		},
		{
			title: "应打卡(次)",
			dataIndex: "should_num",
		},
		{
			title: "实打卡(次)",
			dataIndex: "done_num",
		},
		{
			title: "准时(次)",
			dataIndex: "ontime_num",
		},
		{
			title: "补卡(次)",
			dataIndex: "supplement_num",
			scopedSlots: {
				customRender: "supplement_num"
			}
		},
		{
			title: "缺卡(次)",
			dataIndex: "lack_num",
			scopedSlots: {
				customRender: "lack_num"
			}
		},
		{
			title: "月完成率",
			dataIndex: "completion_rate",
			scopedSlots: {
				customRender: "completion_rate"
			}
		},
		{
			title: "月度明细",
			dataIndex: "pass_status_name2",
			scopedSlots: {
				customRender: "pass_status_name2"
			},
				fixed: 'right',
		},
	];


	let lack_columns = [{
			title: "日期",
			dataIndex: "date",
		},

		{
			title: "应打(次)",
			dataIndex: "should_num",

		},
		{
			title: "实打(次)",
			dataIndex: "done_num",

		},
		{
			title: "缺卡(次)",
			dataIndex: "lack_num",

		},
		{
			title: "具体缺卡时间",
			dataIndex: "lack_times",

		},

	];

	let lack_columns2 = [{
			title: "日期",
			dataIndex: "date",
		},

		{
			title: "补卡(次)",
			dataIndex: "supplement_num",

		},
		{
			title: "补卡时间",
			dataIndex: "supplement_time",

		},
		{
			title: "补卡操作时间",
			dataIndex: "supplement_",

		},
		{
			title: "操作人",
			dataIndex: "work_time",

		},

	];

	const columnsDrawer = [{
			title: '日期',
			dataIndex: 'date',
			align: 'center'
		},
		{
			title: '淡旺季',
			dataIndex: 'season',
			align: 'center',
			scopedSlots: {
				customRender: 'season'
			}
		},
		{
			title: '应打',
			dataIndex: 'should_num',
			align: 'center'
		},
		{
			title: '实打',
			dataIndex: 'done_num',
			align: 'center'
		},
		{
			title: '准时',
			dataIndex: 'ontime_num',
			align: 'center'
		},
		{
			title: '补卡',
			dataIndex: 'supplement_day',
			align: 'center'
		},
		{
			title: '缺卡',
			dataIndex: 'lack_num',
			align: 'center'
		},
		{
			title: '完成率',
			dataIndex: 'completion_rate',
			align: 'center',
			
			scopedSlots: {
				customRender: 'completion_rate'
			}
		}
	]
	export default {
		name: "gpoodIndex",
		components: {
			EditPop,
			Form,
			TableList,
			supInfo,
		},
		data() {
			return {
				data_time:[],
				data_visible:false,
				columns_list_title: '',

				sup_time: [],
				visibleDrawerInfs: {
					info: ''
				},
				columnsDrawer,
				visibleDrawer: false,
				dataSourceDrawer: [],
				num_visible: false,
				visible: false,
				reissuevisible: false,
				submit_string: [],
				type: 1,
				tab_index: 0,
				see_info: {},
				lack_columns2,
				lack_columns,
				dayCount: {
					lack_total: 0,
					lack_user_num: 0,
					qualified_user_num: 0,
					should_total: 0,
					should_user_num: 0
				},
				monthCount: {
					"should_total": 0, //应打卡次数
					"should_user_num": 0, //应打卡人数
					"done_total": 0, //实际打卡次数
					"done_user_num": 0, //实际打卡人数
					"lack_total": 0, //缺卡总次数
					"lack_user_num": 0, //缺卡人数
					"supplement_total": 0, //补卡总次数
					"supplement_user_num": 0, //补卡人数
					"lack_user_avg": 0,
					"qualified_user_num": 0 //月合格人数
				},
				columns_list_subtitle: '',
				see_visible: false,
				drawer_visible: true,
				where: {
					rule_id: ''
				},

				get_table_list: getDayList,
				columns,
				columns_month,
				columns_list: columns,
				columns_list_num: lack_columns,
				visible: false,
				num_list: {},
				form_data: {
					title: '确认补卡',
					list: [{
							type: "slot",
							name: "rule_user",
							title: "",
							options: {},
						}, {
							type: "radio",
							name: "plan_time",
							title: "请选择补卡时间",
							options: {
								initialValue: [],
								rules: [{
									required: false,
								}]
							},
							list: [],
							
						},
						{
							type: 'textarea',
							name: 'remark',
							title: '补卡原因',
							options: {
rules: [{
									required: false,
								}]
							},
						},
						{
							type: 'upload',
							name: 'photo',
							title: '其他凭证',
							options: {
								rules: [{
									required: false,
								}]
							},
						},
					]
				},
				form_data_seo: {
					list: [{
							type: 'text',
							name: 'keyword',
							placeholder: '姓名或者ID',
							title: '姓名',
							options: {
								initialValue: ''
							},
						},
						{
							type: "tree-select",
							name: "department",
							title: "部门",
							options: {},
							treeData: [],
							options: {
								initialValue: ''
							},
							multiple: true
						},
						{
							type: 'text',
							name: 'factory_keyword',
							placeholder: '工厂名称或者ID',
							title: '工厂',
							options: {
								initialValue: ''
							},
						},
						{
							type: 'select',
							name: 'month_pass_status',
							placeholder: '请选择',
							title: ' 班次',
							hidden:false,
							list: [{
									key: '',
									value: '全部'
								}, {
									key: 1,
									value: '白班'
								}, {
									key:2,
									value: '晚班'
								}, {
									key: 0,
									value: '常规'
								},

							],
						},

						{
							type: "range_date",
							name: "range_date",
							title: "时间",
							options: {
								initialValue:[]
							},
							start: {
								name: 'start_time'
							},
							end: {
								name: 'end_time'
							},
							hidden: false
						},
						{
							type: "month",
							name: "month",
							title: "月份",
							options: {
								initialValue: this.$moment(new Date(), 'YYYY/MM')
							},
							hidden: true
						},


					],
					...this.$config.form_data_seo
				},
				tims: {
					info: {}
				},
				submit_preprocessing: {
					array_to_string: ['department', 'role_id']
				}
			};
		},
		async created() {

			this.$method.get_department().then(res => {
				this.form_data_seo.list = this.$method.set_form_list(this.form_data_seo.list, 'department',
					'treeData', res)
			});
			this.$method.get_role_tree().then(res => {
				this.form_data_seo.list.forEach(item => {
					if (item.name == "role_id") {
						item.treeData = res;
					}
				});
			});
			let query = this.$route.query;
			this.$nextTick(() => {
				this.$refs.list.fixed_seo_data = {
					...query,
				}
				this.form_data_seo.list[0].options.initialValue = query.keyword
				this.form_data_seo.list[1].options.initialValue = query.department?Number(query.department):null
				this.form_data_seo.list[2].options.initialValue =query.factory_keyword
				this.form_data_seo.list[4].options.initialValue =[query.start_date,query.end_date]
				
				this.$refs.list.get_list();
			})
			this.get_list_Count()
		},
		methods: {
			handleSubmit(e) {
				let abj = {
					"personnel_id": this.tims.info.personnel_id,
					"date": this.tims.info.date.split('.').join('-'),
					"plan_time": e.values.plan_time,
					"remark": e.values.remark,
					"photo": e.values.photo
				}
				supplementClock({
					data: abj
				}).then(res => {
					this.$refs.list.get_list();
					this.reissuevisible = false
					message.success(res.info);

				})
			},
			goReport() {
				console.log('22',this.visibleDrawerInfs)
				exportMonthDetail({
					data: {
						"personnel_id": this.visibleDrawerInfs.personnel_id,
						"month": this.visibleDrawerInfs.month
					}
				}).then(res => {
					message.success(res.info);
				})
			},
			get_pass_details(info) {
				this.visibleDrawer = true
				getMonthDetail({
					data: {
						"personnel_id": info.personnel_id,
						"month": info.month
					}
				}).then(res => {
					this.visibleDrawerInfs = res.data
					this.visibleDrawerInfs.month = info.month
					this.visibleDrawerInfs.personnel_id = info.personnel_id

				})
			},
			get_reissuevisible(data) {
				getSupplementTimes({
					data: {
						"personnel_id": data.personnel_id,
						"date": data.date.split('.').join('-')
					}
				}).then(res => {
					this.form_data.list[1].list = res.data.list.map(it => {
						return {
							value: it,
							key: it
						}
					})
					this.tims.info = data
					this.reissuevisible = true
				})
			},
			submit(e) {
				let data = e.values;
				if (!data.id) {
					data.id = '';
				}
				saveConfig({
					data: {
						"uids": data.uids ? data.uids.join(',') : '',
						"sub_users": this.rule_user,
						"id": data.id
					},
					info: true,
				}).then(res => {
					this.visible = false;
					this.$refs.list.get_list();
				})
			},

			get_status_list() {
				getSeasonSelect().then(res => {
					this.form_data_seo.list[4].list = res.data.list.map(it => {
						return {
							key: it.value,
							value: it.label,
						}
					})
				})
			},
			show() {
				this.drawer_visible = true;
			},
			see_rule(data) {
				getFactoryRule({
					data: {
						factory_id: data.factory_id
					}
				}).then(res => {
					this.see_info = res.data
					this.see_visible = true
				})
			},
			report() {
				let report_key = "";
				if (this.tab_index == 0) {
					report_key = "sink_frontline_day";
				} else if (this.tab_index == 1) {
					report_key = "sink_frontline_month";
				}
				let query = {
					...this.$refs.list.seo_data
				}
				delete query.keyword
				query.user_search = this.$refs.list.seo_data.keyword
				this.$router.push({
					path: "/report/modify_report",
					query: {
						report_key: report_key,
						...query
					}
				});
			},
			getRateColor(rateStr) {
				const rate = parseFloat(rateStr);
				if (rate >= 100) return '#52c41a'; // 绿色
				if (rate >= 80) return '#fa8c16'; // 橙色
				return '#f5222d'; // 红色
			},
			get_details(item, index) {
				this.$refs.supInfo.get_details(item);
			},
			num_change(info, type) {

				let that = this
				if (this.tab_index == 0 && type == 'lack') {
					getSupplementTimes({
						data: {
							"personnel_id": info.personnel_id,
							"date": info.date.split('.').join('-')
						}
					}).then(res => {
					
						this.data_time =  res.data.list
						this.data_visible = true
					})
				} else {
					if (type == 'lack') {
						this.columns_list_num = this.lack_columns
						this.columns_list_title = '月缺卡明细'
						this.columns_list_subtitle = '缺卡'


					} else {
						this.columns_list_num = this.lack_columns2
						this.columns_list_title = '月补卡明细'
						this.columns_list_subtitle = '补卡'
					}
					getMonthTypeDetail({
						data: {
							"personnel_id": info.personnel_id,
							"month": info.month,
							"type": type
						}
					}).then(res => {
						this.num_list = res.data
						this.num_visible = true


					})
				}

			},
			tab_change(e) {
				let that = this
				this.tab_index = e;
				if (this.tab_index == 0) {
					this.columns_list = this.columns
					this.get_table_list = getDayList
					this.type = 0
					this.form_data_seo.list[1].hidden = false
					this.form_data_seo.list[3].hidden = false
					this.form_data_seo.list[4].hidden = false
					this.form_data_seo.list[5].hidden = true
					this.$nextTick(() => {
						that.$refs.list.pagination.page = 1
						that.$refs.list.get_list();
						that.get_list_Count()
					})
				} else {
					this.type = 1
					this.columns_list = this.columns_month
					this.get_table_list = getMonthList
					this.form_data_seo.list[1].hidden = true
					this.form_data_seo.list[3].hidden = true
					this.form_data_seo.list[4].hidden = true
					this.form_data_seo.list[5].hidden = false
					this.$nextTick(() => {
						that.get_list_Count()
						that.$refs.list.pagination.current = 1
						that.$refs.list.pagination.page = 1
						that.$refs.list.get_list();
					})
				}
			},
			changeStatus(data) {
				this.get_list_Count(data)
			},
			get_list_Count(data) {
				let info = data ? data : {}
				if (this.type == 1) {
					getMonthCount({
						data: {
							...info
						}
					}).then(res => {
						this.dayCount = res.data

					})
				} else {
					getDayCount({
						data: {
							...info
						}
					}).then(res => {
						this.dayCount = res.data
					})
				}

			},

		}
	};
</script>

<style lang="less">
	@import url("../../assets/less/app.less");

	.right_btn {
		text-align: right;
	}

	.max_price_tips {
		margin-left: 99px;
		margin-top: -30px;
		font-size: 13px;
	}

	.float_left {
		margin-right: 8px;
	}

	.max_price_form {
		.item {
			display: flex;

			.right {
				flex: 1;

				.input_number {
					width: 100%;
				}
			}
		}
	}

	.page_content_top {
		display: flex;

		div {
			flex: 1;
			text-align: center;
		}

		div:nth-child(3) {
			cursor: pointer;
		}
	}

	.pointer {
		cursor: pointer;
	}

	.info_item {
		display: flex;
		font-size: 16px;
		line-height: 35px;

		span {
			flex: 1;
			text-align: right;
		}

		span:nth-child(2) {
			flex: 2;
			text-align: left;
			margin-left: 10px;
		}
	}

	.wTime {
		width: 100px;
		height: 32px;
		line-height: 32px;
		background: #E9FFE0;
		color: #246F0A;
		text-align: center;
		margin-bottom: 8px;
	}

	.nowTime {
		width: 100px;
		height: 32px;
		line-height: 32px;
		background: #FDF6EA;
		color: #B97104;
		text-align: center;
	}

	.can {
		width: 100px;
		height: 36px;
		line-height: 36px;
		background: #E9FFE0;
		color: #246F0A;
		text-align: center;
		margin-bottom: 8px;
	}

	.nocan {
		width: 100px;
		height: 36px;
		line-height: 36px;
		background: #FCE6E3;
		color: #F93317;
		text-align: center;
	}

	.red {
		color: #F93317;
	}

	.flex_box {
		display: flex;
	}

	/* 统计卡片通用样式 */
	.stat-card {
		height: 80px;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	/* 颜色主题 */
	.card-blue {
		background-color: #f0f5ff;
		color: #2f54eb;
	}

	.card-cyan {
		background-color: #e6fffb;
		color: #13c2c2;
	}

	.card-red {
		background-color: #fff1f0;
		color: #f5222d;
	}

	.card-orange {
		background-color: #fff7e6;
		color: #fa8c16;
	}
	/* 完成率大卡片 */
	.card-cyan-large {
		background-color: #e6fffb;
		color: #13c2c2;
		height: 184px;
		/* 撑满左侧两行卡片的高度 */
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.stat-value {
		font-size: 20px;
		font-weight: bold;
		line-height: 1.2;
	}

	.stat-value-large {
		font-size: 28px;
		font-weight: bold;
		line-height: 1.2;
	}

	.stat-label {
		font-size: 12px;
		margin-top: 4px;
		color: #666;
		/* 统一灰黑色标签 */
	}

	/* 表格区域样式 */
	.table-container {
		margin-top: 24px;
	}

	.table-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 0;
		border-bottom: 1px solid #f0f0f0;
		margin-bottom: 16px;
	}

	.table-title {
		font-size: 16px;
		font-weight: bold;
		color: #333;
		display: flex;
		align-items: center;
		width: 100%;
	}

	/* 旺季标签 */
	.season-tag {
		background-color: #f6ffed;
		color: #52c41a;
		padding: 2px 8px;
		border-radius: 4px;
		font-size: 12px;
	}

	.page_content_top {
		display: flex;

		div {
			flex: 1;
			text-align: center;
		}
	}
	
	.dateTag{
		padding: 2px 4px;
		border: 1px solid red;
		color:red;
		margin-left: 2px;
	}
</style>